import classNames from 'classnames';
import { useAppContext } from 'context/state';
import { useUserContext } from 'context/user_state';
import Image from 'next/image';
import { forwardRef } from 'react';
import styles from './index.module.scss';
import { SalesBanners } from 'types/enums';

interface Props {
  variant: SalesBanners;
  className?: string;
}

const SIZES = {
  hero: {
    desktop: { width: 1080, height: 320 },
    mobile: { width: 354, height: 260 },
  },
  top: {
    desktop: { width: 1080, height: 60 },
    mobile: { width: 390, height: 60 },
  },
  list: {
    desktop: { width: 640, height: 300 },
    mobile: { width: 354, height: 130 },
  },
  sidebar: {
    desktop: { width: 320, height: 380 },
    mobile: { width: 354, height: 100 },
  },
};

const SalesBanner = forwardRef<HTMLAnchorElement, Props>(({ variant, className }, ref) => {
  const appContext = useAppContext();
  const size = appContext.size.isTabletWidth ? SIZES[variant].mobile : SIZES[variant].desktop;
  const banner =
    appContext?.banners &&
    appContext?.banners?.find((b) => b.position.toUpperCase() === variant.toUpperCase());
  const userContext = useUserContext();
  const platform = appContext.size.isTabletWidth ? 'mobile' : 'desktop';

  if (!banner || !userContext.isLogged) {
    return null;
  }

  return (
    <a
      ref={ref}
      className={classNames(
        styles.root,
        styles[`root__${variant}`],
        {
          [styles[`root__${variant}__mobile`]]: appContext.size.isTabletWidth,
          [styles[`root__${variant}__desktop`]]: !appContext.size.isTabletWidth,
        },
        className,
      )}
      href={banner[platform].referral}
      target='_blank'
      rel='noopener noreferrer'>
      <div
        className={classNames(styles.bannerBlur, {
          [styles.bannerBlur__disable]: variant !== SalesBanners.Top,
        })}></div>
      <Image
        src={banner[platform].image}
        width={size.width}
        height={size.height}
        style={{ height: 'auto', maxWidth: '100%' }}
        className={classNames(styles.img, styles[`img__${variant}`], {
          [styles[`img__${variant}__mobile`]]: appContext.size.isTabletWidth,
          [styles[`img__${variant}__desktop`]]: !appContext.size.isTabletWidth,
        })}
        alt='banner'
      />
    </a>
  );
});

SalesBanner.displayName = 'SalesBanner';

export default SalesBanner;
